import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const AHPDX_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/ahpdx/logo.png",
        alt: "Awakened Heart PDX Logo",
        style: { width: "200px", height: "100%", isMobile: { width: "150px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 181,
  state: "OR",
  departmentIds: [509, 510, 511, 512, 513],
};
